/**
 * LoginDivider Component - Modern Design
 * Visual separator between login methods
 * Follows composition pattern and accessibility guidelines
 */

import React from 'react';
import { Typography } from 'antd';
import { useResponsiveDesign } from '../../hooks/useResponsiveDesign';
import styles from './LoginDivider.module.scss';

const { Text } = Typography;

interface LoginDividerProps {
  text?: string;
  className?: string;
}

const LoginDivider: React.FC<LoginDividerProps> = ({
  text = "OR",
  className = "",
}) => {
  const { isMobile } = useResponsiveDesign();

  return (
    <div className={`${styles.dividerContainer} ${className}`}>
      <div className={styles.dividerLine} />
      <Text 
        className={styles.dividerText}
        style={{ fontSize: isMobile ? '11px' : '12px' }}
        role="separator"
        aria-label="Alternative login methods"
      >
        {text}
      </Text>
      <div className={styles.dividerLine} />
    </div>
  );
};

LoginDivider.displayName = 'LoginDivider';

export default LoginDivider;